import { z } from 'zod'
import { asObjectType } from '@gqloom/zod'

export const SessionAggregatorConfigSchema = z
  .object({
    sessionId: z.string(),
    aggregatorProviderId: z.string(),
    isEnabled: z.boolean(),
    spotLimit: z.number().int().nullable(),
    createdAt: z.date(),
    updatedAt: z.date(),
  })
  .register(asObjectType, {
    name: 'SessionAggregatorConfig',
    description: 'Per-provider spot allocation configuration for a session',
  })

export type SessionAggregatorConfig = z.infer<typeof SessionAggregatorConfigSchema>

export type SessionAggregatorConfigRow = {
  sessionId: string
  aggregatorProviderId: string
  isEnabled: boolean
  spotLimit: number | null
  createdAt: Date
  updatedAt: Date
}

export const SessionAggregatorConfigCreateSchema = z
  .object({
    aggregatorProviderId: z.string(),
    isEnabled: z.boolean().default(true),
    spotLimit: z.number().int().min(0).nullable().optional(),
  })
  .register(asObjectType, {
    name: 'SessionAggregatorConfigInput',
    description: 'Input for configuring a provider on a session',
  })

export type SessionAggregatorConfigCreateInput = z.infer<typeof SessionAggregatorConfigCreateSchema>
